var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGrid = function SvgGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.33333C2 2.59695 2.59695 2 3.33333 2H5.33333C6.06971 2 6.66667 2.59695 6.66667 3.33333V5.33333C6.66667 6.06971 6.06971 6.66667 5.33333 6.66667H3.33333C2.59695 6.66667 2 6.06971 2 5.33333V3.33333Z",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.6667C2 9.93029 2.59695 9.33333 3.33333 9.33333H5.33333C6.06971 9.33333 6.66667 9.93029 6.66667 10.6667V12.6667C6.66667 13.403 6.06971 14 5.33333 14H3.33333C2.59695 14 2 13.403 2 12.6667V10.6667Z",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 3.33333C9.33333 2.59695 9.93029 2 10.6667 2H12.6667C13.403 2 14 2.59695 14 3.33333V5.33333C14 6.06971 13.403 6.66667 12.6667 6.66667H10.6667C9.93029 6.66667 9.33333 6.06971 9.33333 5.33333V3.33333Z",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 10.6667C9.33333 9.93029 9.93029 9.33333 10.6667 9.33333H12.6667C13.403 9.33333 14 9.93029 14 10.6667V12.6667C14 13.403 13.403 14 12.6667 14H10.6667C9.93029 14 9.33333 13.403 9.33333 12.6667V10.6667Z",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
};
export default SvgGrid;